import { OutfitActions } from 'actions/outfit';
import * as MyselfActionTypes from 'actiontypes/myself';

import fetchOutfitSuccess from './fetchOutfitSuccess';

export type IOutfitState = {
  dirty: boolean,
  isChanging: boolean,
  maxOutfits: number,
  Hat: number | undefined,
  Clothing: number | undefined,
  Gloves: number | undefined,
  Weapon: number | undefined,
  Boots: number | undefined,
  Companion: number | undefined,
  Destiny: number | undefined,
  Affiliation: number | undefined,
  Transportation: number | undefined,
  HomeComfort: number | undefined,
  Ship: number | undefined,
  Spouse: number | undefined,
  Club: number | undefined,
}

export const INITIAL_STATE: IOutfitState = {
  dirty: false,
  isChanging: false,
  maxOutfits: 0,
  Hat: undefined,
  Clothing: undefined,
  Gloves: undefined,
  Weapon: undefined,
  Boots: undefined,
  Companion: undefined,
  Destiny: undefined,
  Affiliation: undefined,
  Transportation: undefined,
  HomeComfort: undefined,
  Ship: undefined,
  Spouse: undefined,
  Club: undefined,
};

export default function reducer(state = INITIAL_STATE, action: OutfitActions) {
  switch (action.type) {
    case MyselfActionTypes.CHANGE_OUTFIT_REQUESTED:
    case MyselfActionTypes.EQUIP_QUALITY_REQUESTED:
      return { ...state, isChanging: true };

    case MyselfActionTypes.EQUIP_QUALITY_SUCCESS:
      return fetchOutfitSuccess(state, action);

    case MyselfActionTypes.CHANGE_OUTFIT_SUCCESS:
      return fetchOutfitSuccess(state, action);

    case MyselfActionTypes.FETCH_OUTFIT_SUCCESS:
      return fetchOutfitSuccess(state, action);

    default:
      return state;
  }
}